import { FixedActions } from "@mobility-item-page/dealer/client";
import { isPrivateAdvertiser } from "@mobility-item-page/utilities";
import type { ReactNode } from "react";
import { useAdViewAd, useAdViewMeta } from "src/context/AdViewProviderContext.tsx";
import { CityLink } from "./CityLink.tsx";
import { VideoButton } from "./embedded-video/VideoButton.tsx";
import Favorite from "./Favorite.tsx";
import { ImageGallery } from "./image-gallery/ImageGallery.tsx";
import { ShareButton } from "./sharing/ShareButton.tsx";

type Props = {
  top?: ReactNode;
  left?: ReactNode;
  leftBottom?: ReactNode;
  right?: ReactNode;
  bottom?: ReactNode;
  bottomWide?: ReactNode;
};

export function Layout({ top = <></>, left, right = <></>, leftBottom, bottom, bottomWide }: Props) {
  const { video_url } = useAdViewAd();
  const { ownerUrn } = useAdViewMeta();
  const isPrivateAd = isPrivateAdvertiser(ownerUrn);

  return (
    // biome-ignore lint/correctness/useUniqueElementIds: The skiplink uses this ID
    <div id="ad-start-link" tabIndex={-1}>
      {!isPrivateAd ? <FixedActions /> : null}
      <ImageGallery />
      <div className="flex items-center mt-16 md:mt-40 mb-40">
        <Favorite />
        <ShareButton />
        {video_url ? <VideoButton video_url={video_url} /> : null}
        <CityLink />
      </div>
      {top}
      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-x-32">
        <div className="md:col-span-2">{left}</div>
        <div className="md:col-span-1 md:row-span-2">{right}</div>
        {leftBottom ? <div className="md:col-span-2">{leftBottom}</div> : null}
        {bottomWide ? <div className="md:col-span-3">{bottomWide}</div> : null}
        {bottom ? <div className="md:col-span-2">{bottom}</div> : null}
      </div>
    </div>
  );
}
